/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

export default ConditionalWrapper;
